import React, { ReactElement, useState } from 'react';
import { Form, Select } from 'antd';
import { SelectValue } from 'antd/lib/select';
import { FormInstance } from 'rc-field-form';

import useBreedColors from 'pricing/hooks/useBreedColors/useBreedColors';
import { ContentItemBase } from 'pricing/types';
import { testId } from 'pricing/utilities/test/dataTestId';

const selectAllOption: ContentItemBase = {
  name: 'All',
  id: -10,
};

function FieldPuppyColors(): ReactElement {
  const [breedId, setBreedId] = useState();
  const { breedColors, isBreedColorsLoading } = useBreedColors(breedId);
  const colors = [selectAllOption, ...breedColors].filter((c) => c.id !== 0);

  const onChangeHandler = (value: SelectValue, form: FormInstance) => {
    if ((value as number[]).includes(selectAllOption.id)) {
      const allColorIds = colors
        .filter((c) => c.id !== selectAllOption.id)
        .map((color) => color.id);

      form.setFieldsValue({ colorIds: allColorIds });
    }
  };

  return (
    <Form.Item
      noStyle
      shouldUpdate={(prevValues, curValues) => {
        if (prevValues.breedId !== curValues.breedId) {
          setBreedId(curValues.breedId);
        }
        return prevValues.breedId !== curValues.breedId;
      }}
    >
      {(form) => {
        const breedId = form.getFieldValue('breedId');

        return (
          <Form.Item
            name="colorIds"
            label="Color"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Select
              disabled={!breedId || isBreedColorsLoading}
              data-testid={testId.fieldPuppyColors}
              placeholder="Select"
              loading={isBreedColorsLoading}
              mode="multiple"
              showSearch
              optionFilterProp="children"
              onChange={(value) => onChangeHandler(value, form)}
              filterOption={(input, option) =>
                option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {colors.map((color) => (
                <Select.Option
                  data-testid={testId.fieldPuppyColorOption}
                  key={color.id}
                  value={color.id}
                >
                  {color.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        );
      }}
    </Form.Item>
  );
}

export default FieldPuppyColors;
